<template>
    <Box title="科室报修" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <van-tabs @click="propconfirm" swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex">
            <van-tab :title="'未报修('+DepartmentEquLoadTotal+'台)'">
                <div class="tagsBox">
                    <LoadingFooter v-model="DepartmentEquLoad.loading" :finished="DepartmentEquLoad.finished" @load="onLoad_DepartmentEqu"
                        @scroll="IsSee=false">
                        <div class="commonItems" v-for="item in DepartmentEquList" @click="$router.push({name: 'Repairs', params: {item}})">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>规格型号：</p>
                                            <p>使用科室：</p>
                                            <P>资产序列号:</P>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.EquType}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                            <p class="ellipsis">{{item.EquNumber}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>去报修</div>
                                </div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
            <van-tab :title="'已报修('+DepartmentEquListHasTotal+'台)'">
                <div class="tagsBox">
                    <LoadingFooter v-model="DepartmentEquHasLoad.loading" :finished="DepartmentEquHasLoad.finished"
                        @load="onLoad_DepartmentEquHas">
                        <div class="commonItems" v-for="item in DepartmentEquListHas">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>规格型号：</p>
                                            <p>使用科室：</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.EquType}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
        </van-tabs>
        <transition name="fade">
            <div class="menuArray" v-show="IsSee">
                <Field title="资产名称" placeholder="请输入编号或者名称" @onMessage="value => search.SB = value" />
                <Field title="使用科室" placeholder="请输入使用科室名称" @onMessage="value => search.KB = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import {
        Tab,
        Tabs
    } from 'vant'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'RepairsList',
        components: {
            Box,
            Field,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                page: 1,
                search: {
                    KB: null,
                    SB: '',
                },
                IsSee: true,
                tabsIndex: 0,
                DepartmentEquLoad: {
                    loading: true,
                    finished: false
                },
                DepartmentEquHasLoad: {
                    loading: true,
                    finished: false
                },
                DepartmentEquList: [],
                DepartmentEquLoadTotal: 0, //未报修总数
                touchStartYDepartmentEqu: 0, //

                DepartmentEquListHas: [], //已报修列表
                DepartmentEquListHasTotal: 0,
                pageHas: 1,

            }
        },
        activated() {
            this.DepartmentEquLoadTotal=0;
            this.DepartmentEquListHasTotal=0;
            this.page=1;
            this.pageHas=1;
            this.DepartmentEquList = [];
            this.IsSee=false;
            this.DepartmentEquListHas=[];
            this.loadDataDefaultForDepartmentEqu();
        },
        methods: {
            onScroll(value) {
                if (value > this.touchStartYDepartmentEqu) {
                    this.touchStartYDepartmentEqu = value
                    this.IsSee = false;
                } else if ((this.touchStartYDepartmentEqu - value) > 200) {
                    this.touchStartYDepartmentEqu = value
                    this.IsSee = true;
                }
            },
            propconfirm() { //选项卡切换
                if(this.tabsIndex===0){
                    this.DepartmentEquList.length===0?this.loadDataDefaultForDepartmentEqu():'';
                }else {
                    this.DepartmentEquListHas.length===0?this.loadDataDefaultForDepartmentEquHasLoad():'';
                }
            },
            serach() {
                this.IsSee=false;
                if(this.tabsIndex===0){//未报修
                    this.DepartmentEquList=[];
                    this.page=1;
                    this.loadDataDefaultForDepartmentEqu();
                }else//已报修
                {
                    this.DepartmentEquListHas=[];
                    this.pageHas=1;
                    this.loadDataDefaultForDepartmentEquHasLoad();
                }
            },
            onLoad_DepartmentEqu() { //未报修列表页面上划事件
                if (!this.DepartmentEquLoad.loading && !this.DepartmentEquLoad.finished) {
                    this.page += 1;
                    this.loadDataDefaultForDepartmentEqu();
                }
            },
            onLoad_DepartmentEquHas() { //已报修列表页面上划事件
                if (!this.DepartmentEquHasLoad.loading && !this.DepartmentEquHasLoad.finished) {
                    this.pageHas += 1;
                    this.loadDataDefaultForDepartmentEquHasLoad();
                }
            },
            Search() {
                this.$router.push('/search')
            },
            loadDataDefaultForDepartmentEqu() { //未报修列表查询
                this.$post('/api/Repair/DepartmentEquListNot', {
                    DepartmentId: this.search.KB,
                    EquName: this.search.SB,
                    EquType: '',
                    UserCode: this.$UserInfo.UserId,
                    Store: this.$UserInfo.StoreCode,
                    StartDate: '',
                    EndDate: '',
                    PageIndex: this.page,
                    PageSize: 10,
                    IsEsauCode: false,
                    Token: '1245',
                }).then(result => {
                    this.DepartmentEquLoadTotal = result.Total;
                    for (let i = 0; i < result.DepartmentEquList.length; i++) {
                        this.DepartmentEquList.push(result.DepartmentEquList[i]);
                    }
                    if (this.page * 10 >= this.DepartmentEquLoadTotal) {
                        this.DepartmentEquLoad.loading = false;
                        this.DepartmentEquLoad.finished = true;
                    } else this.DepartmentEquLoad.loading = false;
                })
            },
            loadDataDefaultForDepartmentEquHasLoad() { //已报修列表查询
                this.$post('api/Repair/DepartmentEquListHas', {
                    DepartmentId: this.search.KB,
                    EquName: this.search.SB,
                    EquType: '',
                    UserCode: this.$UserInfo.UserId,
                    Store: this.$UserInfo.StoreCode,
                    StartDate: '',
                    EndDate: '',
                    PageIndex: this.pageHas,
                    PageSize: 10,
                    Token: '12455'
                }).then(result => {
                    this.DepartmentEquListHasTotal = result.Total;
                    for (let i = 0; i < result.DepartmentEquListHas.length; i++) {
                        this.DepartmentEquListHas.push(result.DepartmentEquListHas[i]);
                    }
                    if (this.pageHas * 10 >= this.DepartmentEquListHasTotal) {
                        this.DepartmentEquHasLoad.loading = false;
                        this.DepartmentEquHasLoad.finished = true;
                    } else this.DepartmentEquHasLoad.loading = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menuArray {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .menuArray {
        position: fixed;
        width: 94.667vw;
        z-index: 6;
        top: 26vw;
    }

    .tagsBox {
        margin-top: 20.333vw;
    }

    p,
    span {
        color: #DEDEDE;
    }

</style>



// WEBPACK FOOTER //
// src/page/repairsList/repairsList.vue